import { Component } from '@angular/core';
import { NavController,  ViewController, Config,} from 'ionic-angular';

import { UserMyRadiant as User, Me, RepositoryMyRadiant, HelperMyRadiant, ApiMyRadiant } from '@providers/index';
import { Nav, NavParams, MenuController, Events, ModalController  } from 'ionic-angular';

import { Camera } from '@ionic-native/camera';


import { File } from '@ionic-native/file';
import * as mapboxgl from 'mapbox-gl';
import { PhotoViewer } from '@ionic-native/photo-viewer';

@Component({
  selector: 'detail-activity-employee',
  templateUrl: 'page.html'
})
export class DetailEmployeeActivity {
  loading : any;
  formPermit = {
    type:'',
    date:'',
    purpose:'',
  };
  data = {
    activity: {},
    listType:[{}],
    preview_img : './assets/img/no_img.jpg',
    style : 'mapbox://styles/mapbox/outdoors-v9',
    user:{
      lat : 0,
      lng : 0,
    },
    kantor : {
      lat:-6.240275,
      lng:106.819667
    }
  };
  filePermit:any;
  map = mapboxgl.Map;
  
  
  constructor(
    public navCtrl            : NavController,
    public userApi            : User,
    public menuCtrl           : MenuController,
    public modalCtrl          : ModalController,
    public nav                : Nav,
    public navParams          : NavParams,
    public repositoryProvider : RepositoryMyRadiant,
    public activityProvider   : Me,
    public helper             : HelperMyRadiant,
    public viewCtrl           : ViewController,
    public events             : Events,
    public config             : Config,
    public camera             : Camera,
    public file               : File, 
    public api                : ApiMyRadiant,
    public photoviewer        : PhotoViewer,
    ) {
    this.config.set('backButtonText','Detail Employee Activity');
    // this.getListType();
    this.data.activity = this.navParams.get('data');
    
    mapboxgl.accessToken = 'pk.eyJ1IjoiaGFuYWZpcSIsImEiOiJjangwM2N6ZGkwZ2YzNDlwb2VueDFzYjdjIn0.gJa2aKbVqmJ-nAFn8lc1Xg';
  }

  

  ionViewWillEnter(){
    this.loading = this.helper.showLoading("Loading Map.....");
    this.setting_coordinate(this.data.activity);
  }  

  setting_coordinate(data){
    console.log(data);
    if (data.activity_coordinate != null && data.activity_coordinate != undefined) {
      let coordinate = data.activity_coordinate.split("|");
      console.log(coordinate);
      this.data.user.lng = coordinate[1];
      this.data.user.lat = coordinate[0];
    }
    this.buildMap();
  }


  buildMap() {
    // console.log(this.map);
    this.map = new mapboxgl.Map({
      container: 'map',
      style: this.data.style,
      attributionControl:false,
      zoom: 13,
      center: [this.data.user.lng, this.data.user.lat]
    });
    
    this.map.addControl(new mapboxgl.NavigationControl());
    this.map.on('load',() => {
      new mapboxgl.Marker({
        draggable: false
        }).setLngLat([this.data.user.lng, this.data.user.lat]).addTo(this.map);
      
      try{
        this.loading.dismiss();
      }catch(e){}
    })      
  }

  previewImage(src){
    this.helper.previewFoto(src);
  }

}



// WEBPACK FOOTER //
// ./src/pages/activity/employee/detail/page.ts